import {
  panelOpened,
  hoverHiddenElement,
  hiddenElementsShow,
  clickToOpenLayersPanel,
} from '@wix/bi-logger-editor-data/v2';
import { biLogger } from '#packages/util';

import type { EditorAPI } from '#packages/editorAPI';
import type { HiddenElement } from './hiddenElementsTypes';

const getSectionType = (element: HiddenElement) =>
  element.pageId === 'masterPage' ? 'masterPage' : 'currentPage';

export const reportHoverHiddenElementBI = (element: HiddenElement) =>
  biLogger.report(
    hoverHiddenElement({
      component_id: element.compId,
      component_type: element.compType,
      current_page_name: element.pageId,
      section: getSectionType(element),
    }),
  );

export const reportClickToOpenLayersPanelBI = () => {
  biLogger.report(clickToOpenLayersPanel({}));
  biLogger.report(
    panelOpened({
      origin: 'hidden_panel',
      panel_name: 'panels.toolPanels.layersPanel',
    }),
  );
};

export const reportHiddenElementsShowBI = (
  editorAPI: EditorAPI,
  element: HiddenElement,
) => {
  const getTpaElementParams = () => {
    if (!editorAPI.isTpa(element.compType)) {
      return {};
    }

    const compRef = editorAPI.components.get.byId(
      element.compId,
      element.pageId,
      editorAPI.viewMode.VIEW_MODES.DESKTOP,
    );
    const compData = editorAPI.components.data.get(compRef);
    const appData = editorAPI.dsRead.tpa.app.getData(compData.applicationId);

    return {
      app_id: appData.appDefinitionId,
      app_site_id: appData.instanceId,
      instance_id: element.compId,
    };
  };

  biLogger.report(
    hiddenElementsShow({
      current_page_name: element.pageId,
      component_type: element.compType,
      component_id: element.compId,
      section: getSectionType(element),
      ...getTpaElementParams(),
    }),
  );
};
